import React, { SVGProps } from 'react';

export const SignalStreamIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.54 16.54a1 1 0 0 1-.711-1.703A4.012 4.012 0 0 0 16 12a4.012 4.012 0 0 0-1.171-2.837.999.999 0 1 1 1.422-1.406A5.998 5.998 0 0 1 18.001 12a5.999 5.999 0 0 1-1.75 4.243.995.995 0 0 1-.71.297ZM8.46 16.54a.995.995 0 0 1-.711-.297A5.998 5.998 0 0 1 6 12c0-1.596.621-3.103 1.749-4.243a1 1 0 0 1 1.422 1.406A4.012 4.012 0 0 0 8 12c0 1.066.416 2.074 1.171 2.837a.999.999 0 0 1-.711 1.703Z"
      opacity=".4"
    />
    <path
      fill="currentColor"
      d="M18.69 19a1 1 0 0 1-.741-1.672A7.924 7.924 0 0 0 20 11.999a7.927 7.927 0 0 0-2.051-5.329 1 1 0 1 1 1.482-1.343A9.923 9.923 0 0 1 22 11.998a9.92 9.92 0 0 1-2.568 6.671.99.99 0 0 1-.741.331ZM5.31 19a.997.997 0 0 1-.741-.33A9.923 9.923 0 0 1 2.001 12a9.92 9.92 0 0 1 2.568-6.671 1 1 0 1 1 1.482 1.343A7.924 7.924 0 0 0 4 12.001c0 1.976.729 3.868 2.051 5.329a1 1 0 0 1-.74 1.67Z"
      opacity=".4"
    />
    <path fill="#EE0007" d="M12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
  </svg>
);
